import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';
import _, { isInteger, isNil } from 'lodash';

export function IsIntegerValue(e: number) {
  return (_.isString(e) && _.isEmpty(e)) || isNil(e) || isInteger(e) || i18n.t(LF.ValueMustBeAnInteger);
}
